module.exports = __webpack_public_path__ + "static/media/principal-banner-piece.2dbe3d4f.png";